import './DacRegisterForm.css';
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { get, getDictionaryItem, canUseDOM } from '../../../utils';
import { validateRequired, runValidations, validatePassword, validateRequiredCheckbox, validateEmailRegex, validateLettersOnly, validateMaxLength, validateMinLength, validateAlphaNumericUsername, validatNumericRegex, validateLength } from '../../Login/commomFunctions';
import FormField from '../../Login/components/FormField';
import Password from '../../Login/components/Password';
import Checkboxes from '../../Login/components/Checkboxes';
import DateField from '../../DAcApplication/components/StepsTemplates/components/FormFields/Date';
import Loader from '../../DAcApplication/components/loader';
import { getSessionId } from '../../DAcApplication/utils';
import Modal from './Modal';
import RegistrationInvitationCode from './InvitationCode/RegistrationInvitationCode';
import InjectHTML from './InjectHTML';
import IconVerified from './icon/verified';
import { AGE_LIMIT, OTP_RESEND_DELAY } from './constants';
import { uploadConsent } from '../../DAcApplication/components/actions';
const DacRegisterForm = _ref => {
  let {
    dictionary,
    configuration,
    apiConfig,
    fieldsParams
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const sessionId = getSessionId('register');
  const usernameMaxLength = fieldsParams && fieldsParams.usernameMaxLength ? fieldsParams.usernameMaxLength : 20;
  const usernameMinLength = fieldsParams && fieldsParams.usernameMinLength ? fieldsParams.usernameMinLength : 3;
  const firstNameMaxLength = fieldsParams && fieldsParams.firstNameMaxLength ? fieldsParams.firstNameMaxLength : 50;
  const firstNameMinLength = fieldsParams && fieldsParams.firstNameMinLength ? fieldsParams.firstNameMinLength : 2;
  const lastNameMaxLength = fieldsParams && fieldsParams.lastNameMaxLength ? fieldsParams.lastNameMaxLength : 50;
  const lastNameMinLength = fieldsParams && fieldsParams.lastNameMinLength ? fieldsParams.lastNameMinLength : 2;
  const otpRequiredLength = fieldsParams && fieldsParams.otpRequiredLength ? fieldsParams.otpRequiredLength : 6;
  const [username, setUsername] = useState('');
  const [errorUsername, setErrorUsername] = useState('');
  const [usernameAvailable, setUsernameAvailable] = useState(false);
  const usernameFieldProps = {
    value: username,
    fieldError: errorUsername,
    setError: setErrorUsername,
    label: getDictionaryItem(dictionary, 'username'),
    type: 'text',
    id: 'RegisterUsername',
    name: 'RegisterUsername',
    placeholder: '',
    labelLight: false,
    errorRequired: getDictionaryItem(dictionary, 'usernameRequired') || ' ',
    errorTaken: getDictionaryItem(dictionary, 'usernameisTaken'),
    autoComplete: 'username',
    required: true,
    requiredFromContent: true,
    maxLength: usernameMaxLength,
    errorMaxLength: getDictionaryItem(dictionary, 'usernameMaxLengthError') || ' ',
    minLength: usernameMinLength,
    errorMinLength: getDictionaryItem(dictionary, 'usernameMinLengthError') || ' ',
    errorValue: getDictionaryItem(dictionary, 'usernameInvalid') || ' ',
    changeEvent: value => {
      setUsername(value);
      setUsernameAvailable(false);
      setIsSendOTP(false);
      setCodeOTP('');
      setValiadteError('');
    },
    blurEvent: value => {
      usernameFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : username;
      const validationResult = runValidations([validateRequired, validateMaxLength, validateMinLength, validateAlphaNumericUsername], value, usernameFieldProps);
      return validationResult;
    }
  };
  const [firstname, setFirstname] = useState('');
  const [errorFirstname, setErrorFirstname] = useState('');
  const firstnameFieldProps = {
    value: firstname,
    fieldError: errorFirstname,
    setError: setErrorFirstname,
    label: getDictionaryItem(dictionary, 'firstName'),
    type: 'text',
    id: 'RegisterFirstname',
    name: 'RegisterFirstname',
    placeholder: '',
    labelLight: false,
    errorRequired: getDictionaryItem(dictionary, 'firstNameRequired') || ' ',
    errorValue: getDictionaryItem(dictionary, 'firstNameInvalid') || ' ',
    autoComplete: 'given-name',
    required: true,
    requiredFromContent: true,
    maxLength: firstNameMaxLength,
    errorMaxLength: getDictionaryItem(dictionary, 'firstnameMaxLengthError') || ' ',
    minLength: firstNameMinLength,
    errorMinLength: getDictionaryItem(dictionary, 'firstnameMinLengthError') || ' ',
    changeEvent: value => {
      setFirstname(value);
    },
    blurEvent: value => {
      firstnameFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : firstname;
      return runValidations([validateRequired, validateLettersOnly, validateMaxLength, validateMinLength], value, firstnameFieldProps);
    }
  };
  const [lastname, setLastname] = useState('');
  const [errorLastname, setErrorLastname] = useState('');
  const lastnameFieldProps = {
    value: lastname,
    fieldError: errorLastname,
    setError: setErrorLastname,
    label: getDictionaryItem(dictionary, 'lastName'),
    type: 'text',
    id: 'RegisterLastname',
    name: 'RegisterLastname',
    placeholder: '',
    labelLight: false,
    errorRequired: getDictionaryItem(dictionary, 'lastNameRequired') || ' ',
    errorValue: getDictionaryItem(dictionary, 'lastNameNameInvalid') || ' ',
    autoComplete: 'family-name',
    required: true,
    requiredFromContent: true,
    maxLength: lastNameMaxLength,
    errorMaxLength: getDictionaryItem(dictionary, 'lastnameMaxLengthError') || ' ',
    minLength: lastNameMinLength,
    errorMinLength: getDictionaryItem(dictionary, 'lastnameMinLengthError') || ' ',
    changeEvent: value => {
      setLastname(value);
    },
    blurEvent: value => {
      lastnameFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : lastname;
      return runValidations([validateRequired, validateLettersOnly, validateMaxLength, validateMinLength], value, lastnameFieldProps);
    }
  };
  const [password, setPassword] = useState('');
  const [errorPassword, setErrorPassword] = useState('');
  const passwordFieldProps = {
    value: password,
    fieldError: errorPassword,
    setError: setErrorPassword,
    label: getDictionaryItem(dictionary, 'password'),
    type: 'password',
    id: 'RegisterPassword',
    name: 'RegisterPassword',
    placeholder: '',
    labelLight: false,
    passLink: null,
    errorRequired: getDictionaryItem(dictionary, 'passwordRequired') || ' ',
    errorValue: getDictionaryItem(dictionary, 'passwordIsNotValid') || ' ',
    autoComplete: 'off',
    required: true,
    requiredFromContent: true,
    changeEvent: value => {
      setPassword(value);
    },
    blurEvent: value => {
      passwordFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : password;
      return runValidations([validateRequired, validatePassword, validateMatchPasswordParent], value, passwordFieldProps);
    }
  };
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorConfirmPassword, setErrorConfirmPassword] = useState('');
  const confirmPasswordFieldProps = {
    value: confirmPassword,
    fieldError: errorConfirmPassword,
    setError: setErrorConfirmPassword,
    label: getDictionaryItem(dictionary, 'confirmPassword'),
    type: 'password',
    id: 'RegisterConfirmPassword',
    name: 'RegisterConfirmPassword',
    placeholder: '',
    labelLight: false,
    passLink: null,
    errorRequired: getDictionaryItem(dictionary, 'confirmPasswordRequired') || ' ',
    errorMatchChild: getDictionaryItem(dictionary, 'passwordValidationError') || ' ',
    autoComplete: 'off',
    required: true,
    requiredFromContent: true,
    changeEvent: value => {
      setConfirmPassword(value);
    },
    blurEvent: value => {
      confirmPasswordFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : confirmPassword;
      return runValidations([validateRequired, validateMatchPasswordChild], value, confirmPasswordFieldProps);
    }
  };
  const validateMatchPasswordChild = (value, fieldObj) => {
    if (value === password) {
      fieldObj.setError('');
      return true;
    } else {
      fieldObj.setError(fieldObj.errorMatchChild);
      return false;
    }
  };
  const validateMatchPasswordParent = (value, fieldObj) => {
    if (value === confirmPassword) {
      setErrorConfirmPassword('');
      return true;
    } else {
      //   setErrorConfirmPassword(errorMatchConfirmPassword);
      return false;
    }
  };
  const [email, setEmail] = useState('');
  const [errorEmail, setErrorEmail] = useState('');
  const [emailAvailable, setEmailAvailable] = useState(false);
  const emailFieldProps = {
    value: email,
    fieldError: errorEmail,
    setError: setErrorEmail,
    label: getDictionaryItem(dictionary, 'emailAddress'),
    type: 'email',
    id: 'RegisterEmail',
    name: 'RegisterEmail',
    placeholder: '',
    labelLight: false,
    // maxLength: defaultMaxLength,
    errorRequired: getDictionaryItem(dictionary, 'emailRequired') || ' ',
    errorValue: getDictionaryItem(dictionary, 'emailIsNotValid') || ' ',
    errorValidation: getDictionaryItem(dictionary, 'emailValidationError'),
    successValidation: getDictionaryItem(dictionary, 'emailValidationSuccess'),
    autoComplete: 'email',
    required: true,
    requiredFromContent: true,
    changeEvent: value => {
      setEmail(value);
      setIsSendOTP(false);
      setCodeOTP('');
      setValiadteError('');
    },
    blurEvent: value => {
      emailFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : email;
      return runValidations([validateRequired, validateEmailRegex], value, emailFieldProps);
    }
    // focusEvent: formFillAnalytics
  };
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [errorDateOfBirth, setErrorDateOfBirth] = useState('');
  // const [validateDateOfBirth, setValidateDateOfBirth] = useState(false);
  const dateOfBirthRequired = getDictionaryItem(dictionary, 'dateOfBirthRequired') || ' ';
  const ageIsNotValid = getDictionaryItem(dictionary, 'ageValidationMessage') || ' ';
  const dateOfBirthFieldProps = {
    value: '',
    name: 'RegisterDateOfBirth',
    patternInvalidMessage: errorDateOfBirth,
    required: true,
    validate: true,
    ageLimit: AGE_LIMIT,
    isOnlyPast: true,
    updateContext: obj => {
      const val = obj.RegisterDateOfBirth.value;
      const ageInvalid = obj.RegisterDateOfBirth.ageInvalid;
      setDateOfBirth(val);
      if (ageInvalid) {
        setErrorDateOfBirth(ageIsNotValid);
      } else {
        setErrorDateOfBirth('');
      }
    },
    blurEvent: value => {
      if (!value) validateDateOfBirthRequired(value);
    }
  };
  const validateDateOfBirthRequired = value => {
    value = value.trim();
    if (value.length) {
      setErrorDateOfBirth('');
      return false;
    } else {
      setErrorDateOfBirth(dateOfBirthRequired);
      return true;
    }
  };
  const [checkboxes, setCheckboxes] = useState([{
    name: 'RegisterEmailMarketing',
    id: 'RegisterEmailMarketing',
    value: false,
    label: get(configuration, 'acceptEmailOrMessagesText.jss.value'),
    required: false
  }, {
    name: 'RegisterPrivacyPolicy',
    id: 'RegisterPrivacyPolicy',
    value: false,
    label: get(configuration, 'acceptDGDPRAndPrivacyPolicyText.jss.value'),
    childrenHTML: /*#__PURE__*/React.createElement(InjectHTML, {
      htmlString: get(configuration, `acceptDGDPRAndPrivacyPolicyText.jss.value`)
    }),
    required: true
    //   errorRequired: errorRequiredPrivacyPolicy,
  }]);
  const [errorCheckboxes, setErrorCheckboxes] = useState('');
  const checkboxesFieldProps = {
    checkboxes: checkboxes,
    fieldError: errorCheckboxes,
    setError: setErrorCheckboxes,
    errorRequired: '',
    changeEvent: (name, value) => {
      let checkboxesCopy = checkboxes;
      checkboxesCopy = checkboxesCopy.filter(item => {
        if (item.name === name) {
          item.value = value;
        }
        return item;
      });
      setCheckboxes(checkboxesCopy);
      checkboxesFieldProps.validate();
      //   formFillAnalytics();
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : checkboxes;
      return runValidations([validateRequiredCheckbox], value, checkboxesFieldProps);
    }
  };
  useEffect(() => {
    if (email && !errorEmail && username && !errorUsername) {
      setIsDisableOTP(false);
    } else {
      setIsDisableOTP(true);
    }
  }, [email, errorEmail, username, errorUsername]);

  // OTP
  const [isDisableOTP, setIsDisableOTP] = useState(true);
  const [isSendOTP, setIsSendOTP] = useState(false);
  const [isResendOTP, setIsResendOTP] = useState(false);
  const sendVerifyCode = function (url) {
    let resend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (resend) {
      setIsSendOTP(false);
      setIsResendOTP(false);
      clearTimeout(resendTimer);
      setCodeOTP('');
      setSubmitError('');
    }
    validateUserRegistrationWithEmail();
  };
  const [otpPublicID, setOtpPublicID] = useState('');
  const [validateLoader, setValidateLoader] = useState(false);
  const [valiadteError, setValiadteError] = useState('');
  let resendTimer = null;
  const validateUserRegistrationWithEmail = async () => {
    setValidateLoader(true);
    setValiadteError('');
    const url = `${apiConfig.apiUrl}/v1/proxy/user/register/validate`;
    const headers = new Headers();
    headers.append('X-Request-Id', sessionId);
    headers.append('Apikey', apiConfig.apiKey);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Methods', 'GET,HEAD,POST,OPTIONS');
    headers.append('Access-Control-Allow-Origin', '*');
    const data = {
      RegistrationType: 2,
      ValidateUserRegistrationByEMail: {
        username: username,
        email: email
      }
    };
    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data)
    };
    await fetch(url, requestOptions).then(response => {
      return response.json();
    }).then(result => {
      if (result.hasOwnProperty('desc')) {
        setValiadteError(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
      }
      if (result.hasOwnProperty('Result')) {
        setIsSendOTP(result.Result.Status);
        setUsernameAvailable(result.Result.Status);
        setEmailAvailable(result.Result.Status);
        setOtpPublicID(result.OTPPublicID);
        resendTimer = setTimeout(() => {
          setIsResendOTP(true);
          clearTimeout(resendTimer);
        }, OTP_RESEND_DELAY * 60000);
      }
    }).catch(error => {
      setValiadteError(error.message);
      console.error('validateUserRegistrationWithEmail error', error);
    }).finally(() => setValidateLoader(false));
  };
  const [codeOTP, setCodeOTP] = useState('');
  const [errorCodeOTP, setErrorCodeOTP] = useState('');
  const codeOTPFieldProps = {
    value: codeOTP,
    fieldError: errorCodeOTP,
    setError: setErrorCodeOTP,
    label: getDictionaryItem(dictionary, 'otpLabel'),
    type: 'password',
    id: 'RegisterEnterOTP',
    name: 'RegisterEnterOTP',
    placeholder: '',
    labelLight: false,
    passLink: null,
    errorRequired: getDictionaryItem(dictionary, 'otpRequired') || ' ',
    required: true,
    requiredFromContent: true,
    autoComplete: 'off',
    requiredLength: otpRequiredLength,
    errorValue: getDictionaryItem(dictionary, 'otpIsNotValid') || ' ',
    changeEvent: value => {
      setCodeOTP(value);
    },
    blurEvent: value => {
      codeOTPFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : codeOTP;
      return runValidations([validateRequired, validatNumericRegex, validateLength], value, codeOTPFieldProps);
    }
  };
  const [verifyCode, setverifyCode] = useState(false);
  const checkVerifyCode = () => {
    try {
      // fetch data
      // setverifyCode(true);
    } catch (error) {}
  };
  const [verifyLoader, setVerifyLoader] = useState(false);

  // form submit
  const [submitError, setSubmitError] = useState('');
  const urlRedirect = get(configuration, 'registerAndLoginButton.jss.value.href');
  const formSubmit = event => {
    event.preventDefault();
    submitUserRegistrationWithEmail();
    // setShowModal(true);
  };
  const [submitLoader, setSubmitLoader] = useState(0);
  const submitUserRegistrationWithEmail = async () => {
    setSubmitLoader(prev => prev + 1);
    setSubmitError('');
    const url = `${apiConfig.apiUrl}/v1/proxy/user/register`;
    const apiKey = apiConfig.apiKey || '';
    const headers = new Headers();
    headers.append('X-Request-Id', sessionId);
    headers.append('Apikey', apiKey);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Methods', 'GET,HEAD,POST,OPTIONS');
    headers.append('Access-Control-Allow-Origin', '*');
    const data = {
      RegistrationType: 2,
      UserRegistrationByEMail: {
        username: username,
        email: email,
        firstName: firstname,
        lastName: lastname,
        birthDate: dateOfBirth,
        password: password,
        otp: codeOTP,
        otpPublicId: otpPublicID
      }
    };
    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data)
    };
    await fetch(url, requestOptions).then(response => response.json()).then(result => {
      if (result.hasOwnProperty('desc')) {
        setSubmitError(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
      }
      if (result.hasOwnProperty('Result')) {
        Cookies.set('username', username, {
          expires: 1,
          secure: true
        });

        //call next step for getting token
        authorizeUser();
      }
    }).catch(error => {
      console.error('submitUserRegistrationWithEmail error', error);
      setSubmitError(error.message);
    }).finally(() => setSubmitLoader(prev => prev - 1));
  };
  const [tokenResult, setTokenResult] = useState({});
  const authorizeUser = async () => {
    setSubmitLoader(prev => prev + 1);
    const url = `${apiConfig.apiUrl}/v1/proxy/individual/authenticate`;
    const headers = new Headers();
    headers.append('X-Request-Id', sessionId);
    headers.append('Apikey', apiConfig.apiKey);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Methods', 'GET,HEAD,POST,OPTIONS');
    headers.append('Access-Control-Allow-Origin', '*');
    const data = {
      username: username,
      password: password
    };
    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data)
    };
    await fetch(url, requestOptions).then(response => response.json()).then(result => {
      if (result.hasOwnProperty('desc')) {
        setSubmitError(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
      }
      if (result.hasOwnProperty('access_token')) {
        setTokenResult(result);
        // call next step for submitting invitation code
        // getUserStatus(); //run in useEffect
      }
    }).catch(error => {
      console.error('authorizeUser error', error);
    }).finally(() => setSubmitLoader(prev => prev - 1));
  };
  useEffect(() => {
    if (tokenResult.access_token) {
      getUserStatus();
    }
  }, [tokenResult]);
  const getUserStatus = async () => {
    setSubmitLoader(prev => prev + 1);
    const url = `${apiConfig.apiUrl}/v1/orc/user/${username}/status`;
    const headers = new Headers();
    headers.append('X-Request-Id', sessionId);
    headers.append('Apikey', apiConfig.apiKey);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', `Bearer ${tokenResult.access_token}`);
    headers.append('Host', 'dacqa.detsandbox.com');
    headers.append('User-Agent', 'Apidog/1.0.0 (https://apidog.com)');
    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
      keepalive: true,
      withCredentials: true
    };
    await fetch(url, requestOptions).then(response => {
      if (response.status == 401) {}
      return response.json();
    }).then(result => {
      if (result.hasOwnProperty('desc')) {
        setSubmitError(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
        console.error(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
      }
      if (result.hasOwnProperty('status')) {
        if (result.status === false) {
          setShowModal(true);
        } else {
          callAfterSubmit();
        }
      }
    }).catch(error => {
      setSubmitError(error.message);
      console.error('User Status error', error);
    }).finally(() => setSubmitLoader(prev => prev - 1));
  };
  useEffect(() => {
    if (username && !errorUsername && firstname && !errorFirstname && lastname && !errorLastname && password && !errorPassword && confirmPassword && !errorConfirmPassword && email && !errorEmail && dateOfBirth && !errorDateOfBirth && codeOTP && !errorCodeOTP && checkboxes.filter(item => item.required).every(item => item.value) && !errorCheckboxes) {
      setDisableSubmit(false);
      setSubmitError('');
    } else {
      setDisableSubmit(true);
    }
  }, [username, errorUsername, firstname, errorFirstname, lastname, errorLastname, password, errorPassword, confirmPassword, errorConfirmPassword, email, errorEmail, dateOfBirth, errorDateOfBirth, codeOTP, errorCodeOTP, checkboxes, errorCheckboxes]);
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    if (showModal) {
      document.body.classList.add('prevent-scroll');
    } else {
      document.body.classList.remove('prevent-scroll');
    }
    return () => {
      document.body.classList.remove('prevent-scroll');
    };
  }, [showModal]);
  const redirectToUrl = pathToRedirect => {
    if (canUseDOM) {
      window.location.href = pathToRedirect;
    }
  };
  const insertCookies = () => {
    const expirationDate = new Date(tokenResult.expires_on).getTime();
    const currentDate = new Date().getTime();
    const daysUntilExpiration = Math.round((expirationDate - currentDate) / (1000 * 3600 * 24));
    Cookies.set('token', `Bearer ${tokenResult.access_token}`, {
      expires: daysUntilExpiration,
      secure: true
    });
    Cookies.set('username', username, {
      expires: daysUntilExpiration,
      secure: true
    });
  };
  const callAfterSubmit = async () => {
    const marketingCheckbox = checkboxes.find(item => item.name === 'RegisterEmailMarketing');
    await uploadConsent({
      apiKey: apiConfig.apiKey,
      sessionId
    }, {
      uuids: {
        email: String(email || '').toLocaleLowerCase()
      },
      activity_timestamp: Math.floor(Date.now() / 1000),
      consent_source: 'GDRFA Project',
      custom_parameters: {
        FirstName: firstname || '',
        LastName: lastname || '',
        FormURL: window.location.href || ''
      },
      consent_info: [{
        processing_purpose_id: 5,
        processing_purpose_name: 'Consent for marketing',
        consented_items: [{
          consent_purpose_id: 6,
          consent_granted: marketingCheckbox ? marketingCheckbox.value : false
        }]
      }]
    });
    insertCookies();
    redirectToUrl(urlRedirect);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("form", {
    className: "dac-login-form",
    onSubmit: event => formSubmit(event)
  }, /*#__PURE__*/React.createElement("div", {
    className: "row dac-login-form__inputs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap ${errorUsername ? 'invalid-field' : ''} ${usernameAvailable ? 'valid-field' : ''}`
  }, /*#__PURE__*/React.createElement(FormField, usernameFieldProps), usernameAvailable && /*#__PURE__*/React.createElement(CheckedIcon, null))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap ${errorFirstname ? 'invalid-field' : ''}`
  }, /*#__PURE__*/React.createElement(FormField, firstnameFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap ${errorLastname ? 'invalid-field' : ''}`
  }, /*#__PURE__*/React.createElement(FormField, lastnameFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-group lr__form-group ${errorDateOfBirth ? 'invalid-field' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-label"
  }, getDictionaryItem(dictionary, 'dateOfBirth')), /*#__PURE__*/React.createElement(DateField, dateOfBirthFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap ${errorPassword ? 'invalid-field' : ''}`
  }, /*#__PURE__*/React.createElement(Password, passwordFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap ${errorConfirmPassword ? 'invalid-field' : ''}`
  }, /*#__PURE__*/React.createElement(Password, confirmPasswordFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap ${errorEmail ? 'invalid-field' : ''} ${usernameAvailable ? 'valid-field' : ''}`
  }, /*#__PURE__*/React.createElement(FormField, emailFieldProps), emailAvailable && verifyCode && /*#__PURE__*/React.createElement(CheckedIcon, null), isSendOTP && isResendOTP && !verifyCode && /*#__PURE__*/React.createElement("button", {
    className: "dac-login-form__resend-otp d-none d-md-block",
    type: "button",
    onClick: () => {
      sendVerifyCode(get(configuration, 'sendButton.jss.value.href'), true);
    }
  }, getDictionaryItem(dictionary, 'resendOtp')))), !verifyCode && /*#__PURE__*/React.createElement(React.Fragment, null, isSendOTP ? /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap ${errorCodeOTP ? 'invalid-field' : ''} ${codeOTP && !errorCodeOTP ? 'verified-otp-code' : ''}`
  }, /*#__PURE__*/React.createElement(FormField, codeOTPFieldProps), isSendOTP && isResendOTP && !verifyCode && /*#__PURE__*/React.createElement("button", {
    className: "dac-login-form__resend-otp d-md-none",
    type: "button",
    onClick: () => {
      sendVerifyCode(get(configuration, 'sendButton.jss.value.href'), true);
    }
  }, getDictionaryItem(dictionary, 'resendOtp')))) : /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group lr__form-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-label visibility-hidden d-none d-md-block"
  }, get(configuration, 'sendButton.jss.value.text')), /*#__PURE__*/React.createElement("div", {
    className: "request-failed-wrap"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary dac-login-form__submit",
    disabled: isDisableOTP || validateLoader,
    type: "button",
    name: "SendOtpButton",
    onClick: () => {
      sendVerifyCode(get(configuration, 'sendButton.jss.value.href'));
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: validateLoader ? 0 : 1
    }
  }, get(configuration, 'sendButton.jss.value.text')), validateLoader ? /*#__PURE__*/React.createElement(Loader, null) : false), valiadteError && /*#__PURE__*/React.createElement("b", {
    className: "request-failed"
  }, valiadteError)))))), /*#__PURE__*/React.createElement("div", {
    className: "form-elements dac-login-form__checkboxes"
  }, /*#__PURE__*/React.createElement(Checkboxes, checkboxesFieldProps)), /*#__PURE__*/React.createElement("div", {
    className: "dac-login-form__submit-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "request-failed-wrap"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary dac-login-form__submit",
    type: "submit",
    disabled: disableSubmit || Boolean(submitLoader)
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: Boolean(submitLoader) ? 0 : 1
    }
  }, get(configuration, 'registerAndLoginButton.jss.value.text')), Boolean(submitLoader) ? /*#__PURE__*/React.createElement(Loader, null) : false), submitError && /*#__PURE__*/React.createElement("b", {
    className: "request-failed"
  }, submitError)))), showModal && /*#__PURE__*/React.createElement(Modal, {
    hide: () => setShowModal(false),
    dictionary: dictionary,
    rtl: rtl,
    title: get(configuration, 'invitationSectionTitle.jss.value'),
    description: get(configuration, 'invitationSectionDescription.jss.value') + ` ${email && `<b>${email}</b>`}`,
    children: /*#__PURE__*/React.createElement(RegistrationInvitationCode, {
      dictionary: dictionary,
      configuration: configuration,
      apiConfig: apiConfig,
      sessionId: sessionId,
      hide: () => setShowModal(false),
      callAfterSubmit: callAfterSubmit,
      rtl: rtl,
      username: username,
      email: email
    })
  }));
};
const CheckedIcon = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: "ckecked-icon"
  }, /*#__PURE__*/React.createElement(IconVerified, null));
};
export default DacRegisterForm;
const commonStyles = "c4wze6j";
const ltrStyles = "l1avpxqa";
const rtlStyles = "r1oseorr";